var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data)?_c('catalog',{attrs:{"data":_vm.data},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('h3',[_vm._v("Вы смотрели")])]},proxy:true}],null,false,453935904)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }